import { PERMISSION_KEYS } from 'constants-permissions';
import { ClientTask } from 'graphql-query-contracts';
import { UserDataContext } from 'lane-shared/contexts';
import { hasPermission } from 'lane-shared/helpers';
import { useContext } from 'react';
import { useGenerateServiceRequestFromPmTaskEnabled } from '../feature-flags/useGenerateServiceRequestFromPmTaskEnabled';

interface UseLinkedServiceRequestPermissionsProps {
  channelId: string;
  task: ClientTask;
}

export const useLinkedServiceRequestPermissions = ({
  channelId,
  task,
}: UseLinkedServiceRequestPermissionsProps) => {
  const { user } = useContext(UserDataContext);

  const isGenerateServiceRequestFromPreventiveMaintenanceTaskEnabled =
    useGenerateServiceRequestFromPmTaskEnabled();

  const hasServiceRequestCreatePermission =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_CREATE],
      channelId,
      false
    );

  const shouldDisplayServiceRequests =
    isGenerateServiceRequestFromPreventiveMaintenanceTaskEnabled &&
    task?.serviceRequests &&
    task.serviceRequests.length > 0;

  return {
    hasServiceRequestCreatePermission,
    shouldDisplayServiceRequests,
    isGenerateServiceRequestFromPreventiveMaintenanceTaskEnabled,
  };
};
